import { reactive, ref } from 'vue';
import { tools } from '@/utils/tools.js';
import _ from 'lodash';

export default function useUpdateFields() {
  const conditionList = reactive({
    cascaderList: [10],
    createUser: [6, 22],
    numberList: [7],
    priceList: [16],
    percentageList: [23],
    multipleList: [2, 3, 4, 5],
    dateRangeList: [9]
  });
  const allFields = ref([]);

  // 组装新增全局字段接口参数
  const getGlobalAddParams = ({ fieldType, fieldExt }) => {
    const params = { fieldType };
    fieldExt?.forEach((item, index) => {
      item['sort'] = index;
    });
    params.selections = fieldExt;
    return params;
  };

  // 单选按钮2 多选按钮3 下拉单选4 下拉多选5
  const getSelectFieldExt = ({ entityId, fieldType, fieldKey, globalFieldId, fieldExt, isAdd, entitys, entityList }) => {
    if (!globalFieldId) {
      const fieldExtList = [];
      if (entityId == 4 && fieldType === 4 && fieldKey === 'taxRate') {
        fieldExt?.forEach((item, index) => {
          if (isAdd) {
            fieldExtList.push({
              label: Number(tools.getPercentage(item.label, 0)),
              value: item.value,
              isEnabled: true,
              isRequired: true,
              background: item.background,
              color: item.color
            });
          } else {
            fieldExtList.push({
              label: Number(tools.setPercentage(item.label, 0)),
              value: item.value,
              id: item?.id,
              isEnabled: item?.isEnabled,
              isRequired: item?.isRequired,
              sort: index,
              sortable: item.sortable,
              background: item.background,
              color: item.color
            });
          }
        });
        // 动态记录特殊处理
      } else if (entityId == 16 && fieldType === 4 && fieldKey == 'entityType') {
        entitys?.forEach((item) => {
          const entity = entityList.find((el) => el.entityType == item);
          if (entity)
            fieldExtList.push({
              label: entity.entityName,
              value: entity.entityType
            });
        });
      } else {
        fieldExt?.forEach((item, index) => {
          if (isAdd) {
            fieldExtList.push({
              label: item.label,
              value: item.value,
              isEnabled: true,
              isRequired: true,
              background: item.background,
              color: item.color
            });
          } else {
            fieldExtList.push({
              label: item.label,
              value: item.value,
              id: item?.id,
              isEnabled: item?.isEnabled,
              isRequired: item?.isRequired,
              sort: index,
              sortable: item.sortable,
              background: item.background,
              color: item.color
            });
          }
        });
      }
      if (isAdd) {
        return fieldExtList;
      } else {
        const enabledItems = []; //启用的选项
        const disabledItems = []; //禁用的选项
        for (const item of fieldExtList) {
          (item.isEnabled ? enabledItems : disabledItems).push(item);
        }

        return [...enabledItems, ...disabledItems];
      }
    } else {
      return '';
    }
  };

  // 人员6
  const getPeopleFieldExt = (people) => {
    return JSON.stringify({
      single: people,
      supportChange: 1
    });
  };
  //查找关联数据范围
  const setCondition = (_condition) => {
    _condition?.children?.forEach((item) => {
      item.children?.forEach((child) => {
        if (child?.field && child.field?.length > 0) {
          child.field = Array.isArray(child.field) ? child.field?.join('.') : child.field;
          if (child.conditionType == 0) {
            let _fieldType = child.fieldInfo?.fieldType;
            if (_fieldType == 24) {
              const getFieldExt = JSON.parse(child.fieldInfo?.fieldExt);
              if ([6, 16].includes(getFieldExt?.type)) {
                //计算字段金额
                _fieldType = 16;
              } else if ([23].includes(getFieldExt?.type)) {
                //计算字段百分比
                _fieldType = 23;
              } else if ([5, 7].includes(getFieldExt?.type)) {
                //计算字段数字
                _fieldType = 7;
              }
            }
            if ((Array.isArray(child.value) && child.operation === 'in') || child.operation === 'not_in') {
              if (Array.isArray(child.value[0]) && conditionList.cascaderList?.includes(_fieldType)) {
                child.value = child.value.map((subArr) => subArr?.join('/')).join(',');
              } else {
                child.value = child.value.filter(Boolean)?.join(',');
              }
            } else if (Array.isArray(child.value) && child.operation === 'between') {
              const obj = {
                beginDate: child.value[0],
                endDate: child.value[1]
              };
              const jsonObj = JSON.stringify(obj);
              child.value = jsonObj;
            } else if ((Array.isArray(child.value) && child.operation == 'equals') || child.operation == 'not_equals') {
              if (conditionList.cascaderList?.includes(_fieldType)) {
                child.value = child.value?.join('/');
              }
            }

            if ((conditionList.priceList?.includes(_fieldType) || (tools.isJSON(child.fieldInfo?.fieldExt) && [6, 16].includes(JSON.parse(child.fieldInfo?.fieldExt)?.type))) && child.operation != 'null' && child.operation != 'not_null') {
              child.value = child.value * 10000;
            }

            // 处理百分比字段类型
            if (conditionList.percentageList?.includes(_fieldType) && child.operation != 'null' && child.operation != 'not_null') {
              const decimals = child.fieldInfo?.fieldExt;
              const decimalsPercent = tools.isJSON(decimals) ? JSON.parse(decimals)?.numberFormat || JSON.parse(decimals)?.dataType : 2;
              child.value = tools.setPercentage(child.value, decimalsPercent);
            }
          } else {
            child.value = child.value ? child.value?.join('.') : '';
          }
        }
      });
    });
    return _condition;
  };

  const getFieldTypeByField = (f, i = 0, entity = null) => {
    entity = entity === null ? f[0] : entity;
    const isLeaf = f.length != i + 2 ? false : true;
    const _field = f[i + 1];
    if (f.includes('currentUser')) {
      // debugger;
      return {
        fieldType: 6,
        isLeaf: true,
        label: '当前操作人',
        value: 'currentUser',
        valueRouter: 'currentUser'
      };
    }
    let ret = {};
    allFields.value?.map((af) => {
      if (af.entityType == entity) {
        af.child.map((afc) => {
          if (afc.fieldKey == _field) {
            if (isLeaf) {
              if (afc.fieldType == 21) {
                ret = {
                  ...afc,
                  ...{
                    fieldType: afc?.setting?.business?.fieldType,
                    fieldExt: afc?.setting?.business?.fieldExt
                  }
                };
              } else {
                ret = afc;
              }
            } else {
              ret = getFieldTypeByField(f, i + 1, parseInt(afc.fieldExt));
            }
          }
        });
      }
    });

    return ret;
  };

  //条件筛选默认值处理
  const initConditionFilter = (conditions, fields, selfEntity) => {
    allFields.value = fields;
    console.log('默认数据', conditions, fields);
    const copyConditions = JSON.parse(JSON.stringify(conditions));
    copyConditions?.map((v) => {
      return v.children.map((vc) => {
        if (vc.field && !Array.isArray(vc.field)) vc.field = vc.field.split('.');
        if (selfEntity && vc.field[0] && vc.field[0] != selfEntity) {
          // 老数据
          vc.field.unshift(String(selfEntity));
        }
        vc['fieldInfo'] = getFieldTypeByField(vc.field);

        if (vc.operation != 'null' && vc.operation != 'not_null') {
          if (vc.conditionType == 0) {
            const fieldInfo = vc.fieldConfig;
            console.log('字段信息类型', fieldInfo);

            let ft = fieldInfo?.fieldType;
            if (ft == 24) {
              const getFieldExt = JSON.parse(fieldInfo?.fieldExt);
              if ([6, 16].includes(getFieldExt?.type)) {
                //计算字段金额
                ft = 16;
              } else if ([23].includes(getFieldExt?.type)) {
                //计算字段百分比
                ft = 23;
              } else if ([5, 7].includes(getFieldExt?.type)) {
                //计算字段数字
                ft = 7;
              }
            }
            if (conditionList.createUser?.includes(ft)) {
              vc.value = _.isString(vc.value) && vc?.business && Object.keys(vc?.business)?.length > 0 ? vc.business : vc.value;
              const dept = vc.value?.departIds?.map((v) => v.name) || [];
              const user = vc.value?.userIds?.map((v) => v.name) || [];
              const userIds = vc.value?.userIds?.map((v) => v.id);
              const departIds = vc.value?.departIds?.map((v) => v.id);

              if (userIds?.length) {
                console.log('有值人员', userIds);
                vc.userDeptIds = [...userIds];
              }
              if (departIds?.length) {
                console.log('有值部门', departIds);
                vc.userDeptIds = [...departIds];
              }

              console.log('人员部门333', userIds, vc.userDeptIds);

              vc['userDept'] = [...dept, ...user];
              vc['userList'] = vc.value?.userIds?.map((vu) => {
                return {
                  ...vu,
                  userName: vu.name,
                  avatarOrigin: vu.avatar
                };
              });
              vc['departList'] = vc.value?.departIds?.map((vd) => {
                return {
                  ...vd,
                  departmentName: vd.name,
                  avatarOrigin: vd.avatar
                };
              });
              vc.value = JSON.stringify({
                userIds: userIds,
                departIds: departIds
              });
              // vc.business = null;
            }
            if (vc.operation == 'in' || vc.operation == 'not_in') {
              if (conditionList.cascaderList?.includes(ft)) {
                if (vc.value?.includes('/')) {
                  vc.value = vc.value?.split(',').map((str) => str.split('/'));
                } else {
                  vc.value = vc?.value?.split(',');
                }
              }
              if (conditionList.multipleList.includes(ft) && _.isString(vc.value)) {
                vc.value = vc.value.split(',');
              }
            } else if (vc.operation == 'between') {
              if (conditionList.dateRangeList.includes(ft)) {
                const parsedObject = JSON.parse(vc.value);
                const datesArray = [parsedObject.beginDate, parsedObject.endDate];
                vc.value = datesArray;
              }
            } else {
              // 兼容一下日期类型的数据，如果返回的是数组就变成字符串
              vc.value = Array.isArray(vc.value) ? vc.value?.join() : vc.value;
            }
            //级联
            if (conditionList.cascaderList?.includes(ft) && (vc.operation == 'equals' || vc.operation == 'not_equals')) {
              vc.value = vc.value && typeof vc.value === 'string' ? vc.value?.split('/') : vc?.value;
            }

            //数字
            if (conditionList.numberList?.includes(ft) || [5, 7].includes(tools.isJSON(fieldInfo?.fieldExt) && JSON.parse(fieldInfo?.fieldExt)?.type)) {
              if (vc.value && !isNaN(Number(vc.value))) vc.value = Number(vc.value);
            }
            //价格
            if (conditionList.priceList?.includes(ft) || [6, 16].includes(tools.isJSON(fieldInfo?.fieldExt) && JSON.parse(fieldInfo?.fieldExt)?.type)) {
              if (vc.value && !isNaN(Number(vc.value))) vc.value = Number(vc.value) / 10000;
            }
            //百分比
            if (conditionList.percentageList?.includes(ft)) {
              const percentIsJSON = tools.isJSON(fieldInfo?.fieldExt);
              if (vc.value && !isNaN(Number(vc.value)) && percentIsJSON) {
                vc.value = tools.getPercentage(vc.value, JSON.parse(fieldInfo?.fieldExt)?.numberFormat);
              }
            }
          } else if (vc.conditionType == 1 && vc.value && !Array.isArray(vc.value)) {
            vc.value = vc.value.split('.');
          } else if (vc.conditionType == 2 && typeof vc.value === 'string') {
            vc.value = vc.value?.split(',');
          }
        }
        return vc;
      });
    });
    console.log('默认数据222', copyConditions);
    return copyConditions;
  };

  const checkFilterCondition = ({ _condition, isAdd }) => {
    // const _condition = JSON.parse(JSON.stringify(condition));
    console.log(isAdd);
    let isErrorCondition = false;
    _condition.forEach((item) => {
      item.children.forEach((child) => {
        if (!child.field || child.field.length == 0 || (child.operation != 'null' && child.operation != 'not_null' && child.operation != 'equals_current_value' && ((!child.value && child.value != 0) || child.value?.length == 0))) {
          isErrorCondition = true;
        } else {
          child.field = typeof child.field === 'string' ? child.field : child.field?.join('.');
          if (child.conditionType == 0) {
            let _fieldType = child.fieldInfo?.fieldType;
            if (_fieldType == 24) {
              const getFieldExt = JSON.parse(child.fieldInfo?.fieldExt);
              if ([6, 16].includes(getFieldExt?.type)) {
                //计算字段金额
                _fieldType = 16;
              } else if ([23].includes(getFieldExt?.type)) {
                //计算字段百分比
                _fieldType = 23;
              } else if ([5, 7].includes(getFieldExt?.type)) {
                //计算字段数字
                _fieldType = 7;
              }
            }
            if (Array.isArray(child.value) && (child.operation === 'in' || child.operation === 'not_in')) {
              if (Array.isArray(child.value[0]) && conditionList.cascaderList?.includes(_fieldType)) {
                child.value = child.value.map((subArr) => subArr?.join('/'))?.join(',');
              } else {
                child.value = child.value?.filter(Boolean)?.join(',');
              }
            } else if (Array.isArray(child.value) && child.operation === 'between') {
              const obj = {
                beginDate: child.value[0],
                endDate: child.value[1]
              };
              const jsonObj = JSON.stringify(obj);
              child.value = jsonObj;
            } else if ((Array.isArray(child.value) && child.operation == 'equals') || child.operation == 'not_equals') {
              if (conditionList.cascaderList?.includes(_fieldType)) {
                child.value = child.value?.join('/');
              }
            }
            if (isAdd) {
              //价格
              if ((conditionList.priceList?.includes(_fieldType) || [6, 16].includes(JSON.parse(child.fieldInfo?.fieldExt)?.type)) && child.operation != 'null' && child.operation != 'not_null') {
                child.value = child.value * 10000;
              }
            } else {
              // 价格
              if ((conditionList.priceList?.includes(_fieldType) || (tools.isJSON(child.fieldInfo?.fieldExt) && [6, 16].includes(JSON.parse(child.fieldInfo?.fieldExt)?.type))) && child.operation != 'null' && child.operation != 'not_null') {
                child.value = child.value * 10000;
              }
            }
            //人员 部门
            if (conditionList.createUser?.includes(_fieldType) && child.operation != 'null' && child.operation != 'not_null' && _.isObject(child.value)) {
              child.value = JSON.stringify({
                userIds: _.map(child.value.userIds, 'id'),
                departIds: _.map(child.value.departIds, 'id')
              });
            }

            // 处理百分比字段类型
            if (conditionList.percentageList?.includes(_fieldType) && child.operation != 'null' && child.operation != 'not_null') {
              const decimals = child.fieldInfo?.fieldExt;
              const decimalsPercent = tools.isJSON(decimals) ? JSON.parse(decimals)?.numberFormat : 2;
              child.value = tools.setPercentage(child.value, decimalsPercent);
            }
          } else if (child.conditionType == 2) {
            if (Array.isArray(child.value) && child.value?.length) {
              child.value = child.value?.join(',');
            }
          } else {
            child.value = child.value?.join('.');
          }
        }
      });
    });
    return isErrorCondition;
  };

  // 检测查找关联数据范围是否为空
  const checkCondition = ({ _condition }) => {
    // const _condition = JSON.parse(JSON.stringify(condition));
    let isErrorCondition = false;

    _condition.forEach((item) => {
      item.children.forEach((child) => {
        if (!child.field || child.field.length == 0 || (child.operation != 'null' && child.operation != 'not_null' && ((!child.value && child.value != 0) || child.value?.length == 0))) {
          isErrorCondition = true;
        }
      });
    });

    return isErrorCondition;
  };

  // 处理级联的数据
  const disabledOptions = (options) => {
    const enabledItems = options.filter((item) => item.isEnabled);
    const disabledItems = options.filter((item) => !item.isEnabled);

    const sortedOptions = enabledItems.concat(disabledItems);

    return sortedOptions.map((item) => ({
      ...item,
      children: item.children ? disabledOptions(item.children) : undefined
    }));
  };

  //添加sort顺序
  const setSort = (option) => {
    option?.forEach((item, index) => {
      item.sort = index;

      if (item.children && item.children.length > 0) {
        setSort(item.children);
      }
    });
    return option;
  };
  // 组装编辑全局字段接口参数
  const getGlobalEditParams = ({ fieldType, fieldExt }) => {
    const params = { fieldType };
    const fieldList = [2, 3, 4, 5];
    if (fieldList.includes(fieldType)) {
      const enabledItems = []; //启用的选项
      const disabledItems = []; //禁用的选项
      for (const item of fieldExt) {
        (item.isEnabled ? enabledItems : disabledItems).push(item);
      }
      params.selections = [...enabledItems, ...disabledItems];
    } else if (fieldType === 10) {
      params.selections = disabledOptions(fieldExt);
    }
    params.selections = setSort(params.selections);
    return params;
  };

  const getOptionsTree = (arr, level = 1, path = '') => {
    arr.forEach((item, index) => {
      item.level = level;
      item.sort = index;
      const currentPath = path ? `${path}-${index + 1}` : `${index + 1}`;
      item.key = currentPath;
      if (item.children && item.children.length > 0) {
        getOptionsTree(item.children, level + 1, currentPath);
      }
    });
    return arr;
  };
  const sortOptions = (options) => {
    const enabledItems = options.filter((item) => item.isEnabled);
    const disabledItems = options.filter((item) => !item.isEnabled);

    const sortedOptions = enabledItems.concat(disabledItems);

    return sortedOptions.map((item) => ({
      ...item,
      children: item.children ? sortOptions(item.children) : undefined
    }));
  };

  // 获取级联选项
  const getCascadeFieldExt = ({ fieldExt }) => {
    const fEx = JSON.parse(JSON.stringify(fieldExt));
    const sortedOptions = sortOptions(fEx);
    return getOptionsTree(sortedOptions);
  };
  // 选项类的去重给提示
  const checkForDuplicates = (items) => {
    const labels = new Set();
    const values = new Set();
    for (const item of items) {
      if (labels.has(item.label)) {
        return false;
      }
      if (values.has(item.value)) {
        return false;
      }
      labels.add(item.label);
      values.add(item.value);

      if (item.children?.length) {
        const flag = checkForDuplicates(item.children);
        if (!flag) return flag;
      }
    }
    return true;
  };
  // 检测编码条件有效性
  const validateData = (data) => {
    if (!data || data?.length == 0) {
      return false;
    }
    return data.every((group) => {
      return group.children.every((child) => {
        if (!child.field) {
          return false;
        }
        if (child.operation === 'null' || child.operation === 'not_null') {
          return true;
        } else {
          if (child.value || child.value === 0) {
            return true;
          } else {
            return false;
          }
        }
      });
    });
  };
  // 获取有效字段 ,setting:字段清单，group：表单设计里的字段
  const fieldKeyChange = /^(?!^_|\d+$)(?!.*_$|.*__)[a-zA-Z][a-zA-Z0-9_]*[a-zA-Z0-9]$/;
  // 校验字段名称,字段类型，字段必填，字段状态
  const checkIsRequired = (item) => {
    if (!item?.label || typeof item?.isRequired !== 'boolean' || (typeof item?.isEnabled !== 'boolean' && item.isEnabled == true) || isNaN(parseFloat(item?.fieldType)) || !item?.fieldKey || !fieldKeyChange.test(item.fieldKey)) {
      return false;
    }
    return true;
  };
  const getEffectiveFields = (setting, group) => {
    const getFieldList = [];
    const textFieldList = [0, 1, 6, 7, 8, 9, 11, 16, 22, 23, 26, 27];
    const inputFieldList = [2, 3, 4, 5, 10]; //选项类
    for (const list of group || []) {
      for (const item of list.modules || []) {
        if (textFieldList.includes(item.fieldType) && checkIsRequired(item)) {
          getFieldList.push(item);
        }
        if (inputFieldList.includes(item.fieldType)) {
          if (!item.globalFieldId) {
            //非全局字段
            if (checkIsRequired(item) && item?.fieldExt?.length > 0 && checkForDuplicates(item.fieldExt)) {
              //有选项
              getFieldList.push(item);
            }
            if (checkIsRequired(item) && !item?.fieldExt) {
              //无选项
              getFieldList.push(item);
            }
          } else {
            //全局字段
            item.fieldExt = item.selections;
            getFieldList.push(item);
          }
        }

        if (item?.fieldType == 12 || item?.fieldType == 25) {
          if (
            checkIsRequired(item) &&
            item.fieldExt &&
            item?.popFields?.length > 0 &&
            item.selectFields?.length > 0 &&
            (item.dataRange == 1 ||
              (item.dataRange == 2 &&
                checkCondition({
                  _condition: item.dataRangeConditions?.children
                })))
          ) {
            getFieldList.push(item);
          }
        }
        if (item?.fieldType == 18) {
          //附件
          if (checkIsRequired(item) && item.fieldExt?.limit && ((item.fieldExt?.fileType == 1 && item.fieldExt?.accept) || (item.fieldExt?.fileType == 2 && item.fieldExt?.uploadType))) {
            getFieldList.push(item);
          }
        }
        if (item?.fieldType == 13) {
          //编码
          if (checkIsRequired(item) && item.fieldExt == 1) {
            //普通编码
            getFieldList.push(item);
          }
          if (checkIsRequired(item) && item.fieldExt == 2 && item.encodings?.length > 0) {
            const encodings = item.encodings?.filter((element) => element.type == 2 && (!element?.conditionVo || element?.conditionVo?.children?.length == 0 || !validateData(element.conditionVo.children)));
            if (encodings?.length == 0) {
              //条件编码没有无效的
              getFieldList.push(item);
            }
          }
        }
        if (item?.fieldType == 21) {
          //引用字段
          if (checkIsRequired(item) && item?.fieldExt && item?.fieldExt?.findAssociateField && item?.fieldExt?.referenceField) {
            getFieldList.push(item);
          }
        }
        if (item?.fieldType == 24) {
          //计算字段
          if (checkIsRequired(item) && item?.fieldExt) {
            const fieldExt = item?.fieldExt && tools.isJSON(item?.fieldExt) ? JSON.parse(item.fieldExt) : item?.fieldExt || null;
            if ((fieldExt?.type == 5 || fieldExt?.type == 6) && item?.sum?.relationEntity && item?.sum?.relationField && item?.sum?.sourceField && item?.sum?.sumType) {
              getFieldList.push(item);
            }
            if ((fieldExt?.type == 7 || fieldExt?.type == 23 || fieldExt?.type == 16) && fieldExt?.computeFormula && !isNaN(parseFloat(fieldExt.dataType))) {
              getFieldList.push(item);
            }
            if (fieldExt?.type == 0 && fieldExt?.computeFormula) {
              getFieldList.push(item);
            }
          }
        }
      }
    }
    group.forEach((list) => {
      list?.modules?.forEach((el) => {
        const isExisting = setting.some((item1) => item1.fieldKey === el.fieldKey && item1.isEnabled);
        if (!isExisting) {
          setting.push({ ...el, fieldName: el.label });
        }
      });
    });
    console.log('setting---------', getFieldList, setting, getFieldList);
  };
  return {
    getGlobalAddParams,
    getSelectFieldExt,
    getPeopleFieldExt,
    setCondition,
    validateData,
    checkCondition,
    checkFilterCondition,
    getGlobalEditParams,
    getEffectiveFields,
    getCascadeFieldExt,
    initConditionFilter
  };
}
